const DETROIT = 'America/Detroit';

function formatLastSeen(value) {
  if (value == null || value === '') return 'last seen: —';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'last seen: —';

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: DETROIT,
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  }).formatToParts(date);
  const get = (type) => parts.find((part) => part.type === type)?.value || '';
  const ampm = get('dayPeriod').toLowerCase().replace(/\./g, '');
  return `last seen: ${get('month')}/${get('day')}/${get('year')} ${get('hour')}:${get('minute')}${ampm}`;
}

function settingsIntervalFields(storedSec) {
  const n = Number(storedSec);
  if (!Number.isFinite(n) || n <= 5) {
    return { value: 180, unit: 'sec' };
  }
  if (n >= 86400 && n % 86400 === 0) {
    return { value: n / 86400, unit: 'days' };
  }
  if (n >= 3600 && n % 3600 === 0) {
    return { value: n / 3600, unit: 'hours' };
  }
  if (n >= 60 && n % 60 === 0) {
    return { value: n / 60, unit: 'min' };
  }
  return { value: n, unit: 'sec' };
}

function sampleIntervalAllowed(seconds) {
  const n = Number(seconds);
  return Number.isFinite(n) && n > 5;
}

function intervalInputMin(unit) {
  return unit === 'sec' ? 6 : 1;
}

function chartYRange(temps) {
  const values = (temps || []).filter(
    (value) => typeof value === 'number' && Number.isFinite(value),
  );
  if (!values.length) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min;
  const pad = span === 0 ? 1 : Math.max(span * 0.08, 0.5);
  return [min - pad, max + pad];
}

function sensorDisplayName(stored, which) {
  const text = String(stored == null ? '' : stored).trim().slice(0, 16);
  if (text) return text;
  return Number(which) === 2 ? 'Sensor 2' : 'Sensor 1';
}

function chartSeriesName(reading, device) {
  const probe = Number(reading && reading.probe);
  const which = probe === 2 ? 2 : 1;
  const stored =
    device && (which === 2 ? device.sensor2_name : device.sensor1_name);
  return sensorDisplayName(stored, which);
}

function readingMatchesProbeChoice(reading, choice) {
  if (choice == null || choice === 'both') return true;
  const probe = Number(reading && reading.probe);
  if (String(choice) === '0') return probe === 1;
  if (String(choice) === '1') return probe === 2;
  return true;
}

function eraseReadingsConfirmMessage(deviceName) {
  const name = String(deviceName || '').trim() || 'this device';
  return `Erase every stored temperature reading for ${name}? This cannot be undone.`;
}

module.exports = {
  formatLastSeen,
  eraseReadingsConfirmMessage,
  sampleIntervalAllowed,
  intervalInputMin,
  chartYRange,
  settingsIntervalFields,
  sensorDisplayName,
  chartSeriesName,
  readingMatchesProbeChoice,
};
